// Types
import type { FC } from "react";

// Base
import { RegionDropdown } from "react-country-region-selector";

// Assets
import { DropdownArrow } from "@/assets/Icons";

interface RegionFieldProps {
  label: string;
  error?: string;
  country?: string;
  handleChange: (val: string, name?: string) => void;
  name: string;
  value?: string;
  contrast?: boolean;
}

const RegionField: FC<RegionFieldProps> = ({
  label,
  error,
  country,
  handleChange,
  name,
  value,
  contrast,
}) => {
  return (
    <div className="flex w-full flex-col gap-1">
      <label
        className={`text-sm font-bold whitespace-nowrap ${
          contrast ? "text-cc-dark-gray" : "text-cc-gray"
        }`}
        htmlFor={name}
      >
        {label}
      </label>
      <div className="relative">
        <RegionDropdown
          id="region"
          country={country?.toUpperCase() ?? ""}
          countryValueType="short"
          valueType="short"
          name={name}
          value={value ?? ""}
          defaultOptionLabel={label}
          autoComplete="address-level1"
          onChange={(val: string) => handleChange(val, name)}
          className={`w-full appearance-none rounded-md border bg-white p-4 text-sm ${
            contrast ? "border-cc-gray-5" : "border-cc-gray-4"
          }`}
          style={{
            color: contrast ? "#333333" : "#0A0A0A",
          }}
        />

        <div className="pointer-events-none absolute top-1/2 right-4 flex -translate-y-1/2 items-center">
          <DropdownArrow />
        </div>
      </div>

      {error && <div className="mt-1 text-xs text-red-500">{error}</div>}
    </div>
  );
};

export default RegionField;
